import axios from "axios";
import { getSessionStorageItem } from "./sessionStorageUtils";
import { notifyError } from "../components/Toaster/Toaster";

//const DEFAULT_API_URL = 'http://localhost:88'; 
const DEFAULT_API_URL='http://wosh.mizulink.com:88';
//console.log('All env variables:', process.env); // Debug all env variables
const api = axios.create({
  baseURL:  process.env.REACT_APP_API_URL_HTTPS || DEFAULT_API_URL,
});
//local
/*const api = axios.create({
  baseURL:  process.env.REACT_APP_API_URL_HTTPS,
});*/
//console.log('Environment API URL:', process.env.REACT_APP_API_URL_HTTPS);
//console.log('Axios instance baseURL:', api.defaults.baseURL);
/*const apiUrl = "http://localhost:88"
const axiosInstance = axios.create({
  baseURL: apiUrl,
  // You can add other headers or configuration options here
});*/
// Flag to track if unauthorized error occurred
let unauthorizedErrorOccurred = false;

// Request interceptor to cancel subsequent requests if unauthorized error occurred
api.interceptors.request.use(
  (config) => {
    if (unauthorizedErrorOccurred) {
      const cancelSource = axios.CancelToken.source();
      config.cancelToken = cancelSource.token;
      cancelSource.cancel('Request canceled due to previous unauthorized error');
    }
    const token = getSessionStorageItem("haqt_userinfo");
    if (token) {
      config.headers.Authorization = `Bearer ${token.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to catch unauthorized error
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle error globally here
    if (error.response) {
      if (error.response.status === 401) {
        unauthorizedErrorOccurred = true;
        sessionStorage.clear();
        notifyError(error.response.data.errorList.join(" "));
        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
      } else {
        notifyError(error.response.data.errorList.join(" "));
      }
    }
    return Promise.reject(error);
  },
);

export const postRequest = (url, userData, options = {}) => {
  return api.post(url, userData, options);
};

export const getRequest = (url) => {
  return api.get(url);
};

export const putRequest = (url, userData) => {
  return api.put(url, userData);
};

export const deleteRequest = (url) => {
  return api.delete(url);
};
